module.exports = __webpack_public_path__ + "static/media/Tw.bb01402e.svg";